<template>
    <div class="sleep-stages" v-if="sleepStages">
      <label class="title">Sleep Stages</label>
      <div class="range-label">
        <span style="font-size: 0.85rem;">Typical Range</span> 
        <span class="range-indicator"></span></div>
      <div v-if="sleepStages">  
        <div class="stage" v-for="stage in sleepStages" :key="stage.name">
          <div class="progress-bar-container">
            <div class="progress-bar" :style="{ width: stage.percentage + '%', backgroundColor: stage.color }"></div>
            <div class="progress-marker" :style="{ left: stage.marker + '%' }"></div>
          </div>
          <div class="stage-info">
            <div class="d-flex align-items-center">
              <span class="stage-name">{{ stage.name }}</span>
              <span class="stage-percentage">{{ stage.percentage }}%</span>
            </div>
            <span class="stage-duration">{{ stage.duration }}</span>
          </div>
        </div>
      </div>  
    </div>
</template>
  
<script>
import Utils from "@/helpers/utils";

  export default {
    name: "SleepStages",
    props: {
      sleepData: {
        type: Object,
        required: false,
      }
    },
    data() {
      return {
        sleepStages: null,
      };
    },
    mounted() {
      this.sleepStages = [];
      this.prepareSleepStages();
    },
    watch: {
      sleepData() {
        this.prepareSleepStages();
      }
    },
    methods: {
      formatDurationInHrsAndMins(minutes) {
        let sleepSeconds = minutes * 60;
        return Utils.formatDurationInHrsAndMins(sleepSeconds);
      },
      getSleepPercentage(categoryMins) {
        let percentage= Math.round(categoryMins/this.sleepData.sleep_minutes * 100);
        return percentage;
      },
      prepareSleepStages() {
        this.sleepStages = [
            {
              name: "Awake",
              percentage: this.getSleepPercentage(this.sleepData.awake_minutes),
              duration: this.formatDurationInHrsAndMins(this.sleepData.awake_minutes),
              color: "yellow",
              marker: this.getSleepPercentage(this.sleepData.awake_minutes),
            },
            {
              name: "Light Sleep",
              percentage: this.getSleepPercentage(this.sleepData.light_sleep_minutes),
              duration: this.formatDurationInHrsAndMins(this.sleepData.light_sleep_minutes),
              color: "#c2dbdd",
              marker: this.getSleepPercentage(this.sleepData.light_sleep_minutes),
            },
            {
              name: "REM Sleep",
              percentage: this.getSleepPercentage(this.sleepData.rem_sleep_minutes),
              duration: this.formatDurationInHrsAndMins(this.sleepData.rem_sleep_minutes),
              color: "#6bb4b2",
              marker: this.getSleepPercentage(this.sleepData.rem_sleep_minutes),
            },
            {
              name: "Deep Sleep",
              percentage: this.getSleepPercentage(this.sleepData.deep_sleep_minutes),
              duration: this.formatDurationInHrsAndMins(this.sleepData.deep_sleep_minutes),
              color: "#073e47",
              marker: this.getSleepPercentage(this.sleepData.deep_sleep_minutes),
            },
        ];

        //check if total percentage is 100 or not, if not because of rounding adjust total to 100
        let sleepTotPercentage = this.sleepStages.reduce((n, {percentage}) => n + percentage, 0);
        let percentageDiff = 100 - sleepTotPercentage;

        if(percentageDiff > 0) {
          this.sleepStages[1].percentage = this.sleepStages[1].percentage - percentageDiff;
        } else if(percentageDiff < 0) {
          this.sleepStages[1].percentage = this.sleepStages[1].percentage + percentageDiff;
        }
      }
    },
  };
</script>
  
<style lang="scss" scoped>
  .sleep-stages {
    background-color: #121212;
    color: white;
    padding: 1.5rem;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border-radius: 0.5rem;
  }
  
  h2 {
    font-size: 1rem;
    margin-bottom: 1.2rem;
  }
  
  .range-label {
    font-size: 0.7rem;
    color: #aaa;
    text-align: right;
    margin-bottom: 0.5rem;
  }
  
  .range-indicator {
    display: inline-block;
    width: 0.85rem;
    height: 0.85rem;
    background-color: rgba(255, 255, 255, 0.6);
    margin-left: 0.5rem;
  }
  
  .stage {
    margin-bottom: 1rem;
  }
  
  .stage-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.85rem;
    margin-top: 0.3rem;
  }
  .stage-percentage {
    padding-left: 0.25rem;
    font-size: 0.85rem;
    color: #aaa;
  }
  
  .progress-bar-container {
    position: relative;
    background-color: #333;
    height: 1rem;
    overflow: hidden;
  }
  
  .progress-bar {
    height: 100%;
  }
  
  .progress-marker {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 0.7rem;
    background-color: rgba(255, 255, 255, 0.6);
    margin-left:-0.25rem;
  }
  .title {
    font-size: 1rem;
    font-weight: bold;
  }
</style>
  